import type { CSSProperties } from 'react';

interface Properties {
  width?: number;
  height?: number;
  style?: CSSProperties;
}

/** "Calc1" indicator badge (Calculation type) — provided asset, fixed colours. */
const FigmaCalc1Icon = ({ width = 20, height = 20, style }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 52 52'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={style}
  >
    {/* No clipPath: it was a full-viewBox rect that clipped nothing, and
        every instance repeated the same id — the browser resolves the ref to
        whichever copy is first in the document, so icons blanked out when that
        copy unmounted. */}
    <g>
      <path
        d='M40.625 0H11.375C5.09276 0 0 5.09276 0 11.375V40.625C0 46.9072 5.09276 52 11.375 52H40.625C46.9072 52 52 46.9072 52 40.625V11.375C52 5.09276 46.9072 0 40.625 0Z'
        fill='#11CDDA'
      />
      <path
        d='M37.375 8.125H14.625C12.3813 8.125 10.5625 9.94384 10.5625 12.1875V39.8125C10.5625 42.0562 12.3813 43.875 14.625 43.875H37.375C39.6187 43.875 41.4375 42.0562 41.4375 39.8125V12.1875C41.4375 9.94384 39.6187 8.125 37.375 8.125Z'
        stroke='white'
        strokeWidth='2.03125'
      />
      <path
        d='M34.5312 13H17.4688C16.3469 13 15.4375 13.9094 15.4375 15.0312V19.0938C15.4375 20.2156 16.3469 21.125 17.4688 21.125H34.5312C35.6531 21.125 36.5625 20.2156 36.5625 19.0938V15.0312C36.5625 13.9094 35.6531 13 34.5312 13Z'
        fill='white'
      />
      <path
        d='M19.5 26H16.6562C15.9832 26 15.4375 26.5457 15.4375 27.2188V28.8438C15.4375 29.5168 15.9832 30.0625 16.6562 30.0625H19.5C20.1731 30.0625 20.7188 29.5168 20.7188 28.8438V27.2188C20.7188 26.5457 20.1731 26 19.5 26Z'
        fill='white'
      />
      <path
        d='M27.4219 26H24.5781C23.905 26 23.3594 26.5457 23.3594 27.2188V28.8438C23.3594 29.5168 23.905 30.0625 24.5781 30.0625H27.4219C28.095 30.0625 28.6406 29.5168 28.6406 28.8438V27.2188C28.6406 26.5457 28.095 26 27.4219 26Z'
        fill='white'
      />
      <path
        d='M35.3438 26H32.5C31.8269 26 31.2812 26.5457 31.2812 27.2188V28.8438C31.2812 29.5168 31.8269 30.0625 32.5 30.0625H35.3438C36.0168 30.0625 36.5625 29.5168 36.5625 28.8438V27.2188C36.5625 26.5457 36.0168 26 35.3438 26Z'
        fill='white'
      />
      <path
        d='M19.5 32.5H16.6562C15.9832 32.5 15.4375 33.0457 15.4375 33.7188V35.3438C15.4375 36.0168 15.9832 36.5625 16.6562 36.5625H19.5C20.1731 36.5625 20.7188 36.0168 20.7188 35.3438V33.7188C20.7188 33.0457 20.1731 32.5 19.5 32.5Z'
        fill='white'
      />
      <path
        d='M27.4219 32.5H24.5781C23.905 32.5 23.3594 33.0457 23.3594 33.7188V35.3438C23.3594 36.0168 23.905 36.5625 24.5781 36.5625H27.4219C28.095 36.5625 28.6406 36.0168 28.6406 35.3438V33.7188C28.6406 33.0457 28.095 32.5 27.4219 32.5Z'
        fill='white'
      />
      <path
        d='M35.3438 32.5H32.5C31.8269 32.5 31.2812 33.0457 31.2812 33.7188V35.3438C31.2812 36.0168 31.8269 36.5625 32.5 36.5625H35.3438C36.0168 36.5625 36.5625 36.0168 36.5625 35.3438V33.7188C36.5625 33.0457 36.0168 32.5 35.3438 32.5Z'
        fill='white'
      />
    </g>
  </svg>
);

export default FigmaCalc1Icon;
